"use strict";

var _classCallCheck = require("/app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/app/node_modules/@babel/runtime/helpers/createClass");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var AbstractVideoEmbedder_1 = require("./AbstractVideoEmbedder");

var TwitchEmbedder_1 = require("./TwitchEmbedder");

var VimeoEmbedder_1 = require("./VimeoEmbedder");

var YoutubeEmbedder_1 = require("./YoutubeEmbedder");

var VideoEmbedders =
/*#__PURE__*/
function () {
  function VideoEmbedders() {
    _classCallCheck(this, VideoEmbedders);
  }

  _createClass(VideoEmbedders, null, [{
    key: "processTextNodeAndInsertEmbeds",
    value: function processTextNodeAndInsertEmbeds(node) {
      var out = {
        links: [],
        images: []
      };
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = VideoEmbedders.LIST[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var embedder = _step.value;
          var markResult = embedder.markEmbedIfFound(node);

          if (markResult) {
            if (markResult.image) out.images.push(markResult.image);
            if (markResult.link) out.links.push(markResult.link);
          }
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return != null) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      return out;
    }
  }, {
    key: "insertMarkedEmbedsToRenderedOutput",
    value: function insertMarkedEmbedsToRenderedOutput(input, size) {
      return AbstractVideoEmbedder_1.AbstractVideoEmbedder.insertAllEmbeds(VideoEmbedders.LIST, input, size);
    }
  }]);

  return VideoEmbedders;
}();

VideoEmbedders.LIST = [//
new YoutubeEmbedder_1.YoutubeEmbedder(), new VimeoEmbedder_1.VimeoEmbedder(), new TwitchEmbedder_1.TwitchEmbedder()];
exports.VideoEmbedders = VideoEmbedders;